<template>
  <div>
    <div class="mini-prod-card">
      <div class="cross-item width156 mr12 flex-column justify-content-between">
        <div
          class="mpc-img pr"
          :style="{
            backgroundImage: `url(${getImageUrl(cardItem)})`,
            backgroundSize: 'contain',
          }"
        >
          <!-- <div v-if="discountMessage" class="cross-sell-discount">
            <p class="fs-11">{{ discountMessage }}</p>
          </div> -->
          <!-- <div
            v-if="mostPopular"
            class="most-popular"
            :style="{ background: tagBgColor, color: tagColor }"
          >
            <p class="fs-10 bold">{{ mostPopular }}</p>
          </div> -->

          <div class="mpc-item-body">
            <div class="mpc-item-tag mb5">
              <i :class="[isVeg ? 'tag-veg' : 'tag-non-veg']"></i>
            </div>
            <div class="fs-12 tl multi-line-ellipses-v2 mh-28 color-white">
              {{ cardItem?.productMetadata?.name || cardItem?.displayName }}
            </div>
            <div class="flex-row justify-content-between align-items-center">
              <div class="price">
                <span class="rs">Rs.</span>
                <span class="bold">{{
                  cardItem?.productMetadata?.currentPrice ||
                  cardItem?.selectedVariant?.price?.currentPrice ||
                  0.0
                }}</span>
              </div>

              <div class="main-cta">
                <div
                  v-if="quantity > 0"
                  class="btn cta-edit medium cta-edit-cart"
                >
                  <span
                    class="anim-ico-minus item-status-anim"
                    @click="removefromcart(cardItem)"
                    v-ripple
                  >
                  </span>
                  <span class="item-quantity">{{ quantity }}</span>
                  <span
                    class="anim-ico-plus item-status-anim"
                    @click="addtocart(cardItem)"
                    v-ripple
                  ></span>
                </div>
                <button
                  class="btn bold hand cta-add secondary"
                  @click="addtocart(cardItem)"
                  v-else
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import {
  keyMapsGetter,
  keyMapsMutation,
  keyMapsAction,
} from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import {
  EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE,
  EVENT_CART_CROSS_SELL_COLLAPSE,
} from "../helpers/analyticsEvents";

export default {
  name: "MiniProductCard",
  components: {},
  props: {
    cardItem: { required: true, default: false },
    strickPriceEnable: { required: false, default: false },
    strickPrice: { required: false, default: 0 },
    dataItemIndex: { required: false, default: 0 },
    totalItems: { required: false, default: 0 },
    skuId: { required: false, default: 0 },
  },
  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  methods: {
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    addToCartEvents(productItem) {
      const {
        isVeg,
        displayName,
        parentSkuId,
        selectedVariant,
        productMetadata,
      } = productItem;
      EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE({
        cartId: LocalStorageFunc.cartId(),
        itemSKU: Utility.getProductSkuId(productItem),
        quantity: 1,
        isVegItem: isVeg ? "Veg" : "Non veg",
        itemName: displayName,
        itemOriginalPrice: productMetadata?.regularPrice,
        price: productMetadata?.currentPrice,
        itemPosition: this.dataItemIndex + 1,
        positionWithinSection: this.dataItemIndex + 1,
        itemCategory: parentSkuId,
        isCustomizedItem: selectedVariant?.defaultVariant ? "No" : "Yes",
      });

      if (this.totalItems.length == 1) {
        EVENT_CART_CROSS_SELL_COLLAPSE();
      }
    },
    addtocart(productItem) {
      this.addToCartEvents(productItem);
      let product =
        this.$store.state.ProductItems.products[
          this.$store.state.ProductItems.productCategoryMap[
            Utility.getProductSkuId(productItem?.productMetadata || productItem)
          ] &&
            Object.keys(
              this.$store.state.ProductItems.productCategoryMap[
                Utility.getProductSkuId(
                  productItem?.productMetadata || productItem,
                )
              ],
            )[0]
        ][Utility.getProductSkuId(productItem?.productMetadata || productItem)];
      this.$store.commit(
        keyMapsMutation.ADD_TO_CART,
        product.variants?.find((x) => (x.skuId = this.skuId))
          ? {
              ...product,
              selectedVariant: product.variants?.find(
                (x) => (x.skuId = this.skuId),
              ),
            }
          : { ...product },
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart.",
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
      if (Utility.isCurrentlyAtUrl("/cart")) {
        this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API, {});
      }
    },
    removefromcart(productItem) {
      this.$store.commit(
        keyMapsMutation.REMOVE_FROM_CART,
        this.getLastAddedItemFromCart(
          Utility.getProductSkuId(productItem?.productMetadata || productItem),
        ),
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item removed from the cart.",
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
    },
    getImageUrl(cardItem) {
      let url = "";
      if (cardItem?.productMetadata) {
        cardItem?.productMetadata?.mediaMetadata?.length &&
          cardItem?.productMetadata?.mediaMetadata.map((x) => {
            if (x.mediaType === "IMAGE") {
              url =
                x.url ||
                staticImgBaseUrl + "/images/global/PlaceholderImage.png";
            }
          });
      } else {
        let mediaBaseUrl = this.$store.state.ProductItems.imgBaseUrl;
        const mediaUrl = cardItem?.mediaList?.[0]?.mediaUrls?.upsell;
        url = mediaUrl
          ? mediaUrl.includes("https")
            ? mediaUrl
            : mediaBaseUrl + mediaUrl
          : staticImgBaseUrl + "/images/global/PlaceholderImage.png";
      }
      return url;
    },
  },
  computed: {
    discountMessage() {
      let discountMessage = "";
      this.cardItem.productMetadata?.properties?.map((x) => {
        if (x.key === "discount_message") {
          discountMessage = x.values;
        }
      });
      return discountMessage;
    },
    mostPopular() {
      return this.cardItem.productMetadata?.metadataMap?.value_tag?.values[0];
    },
    tagBgColor() {
      return this.cardItem.productMetadata?.metadataMap?.value_tag_bgColor
        ?.values[0];
    },
    tagColor() {
      return "color-white";
    },
    quantity() {
      let quantity = 0;
      let productItems =
        this.$store.state.Cart.items[
          Utility.getProductSkuId(
            this.cardItem?.productMetadata || this.cardItem,
          )
        ];
      if (Array.isArray(productItems) && productItems.length > 0) {
        quantity = productItems.length;
      }
      return quantity;
    },
    getLastAddedItemFromCart() {
      return (productId) => {
        return this.$store.getters[keyMapsGetter.GET_LAST_ADDED_ITEM_FROM_CART](
          productId,
        );
      };
    },
    isVeg() {
      return this.cardItem?.isVeg ?? !this.cardItem?.isNonVeg;
    },
  },
};
</script>

<style></style>
